import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/PageHeader';
import RsvpForm, { RsvpFormData } from '../components/RsvpForm';
import { supabase } from '../lib/supabase';
import { v4 as uuidv4 } from 'uuid';

const RsvpPage: React.FC = () => {
  const navigate = useNavigate();

  const handleSubmit = async (data: RsvpFormData) => {
    try {
      const { error } = await supabase
        .from('guests')
        .insert({
          id: uuidv4(),
          name: data.name,
          phone: data.phone,
          guests_count: data.guestsCount,
          message: data.message || null,
          created_at: new Date().toISOString()
        });
        
      if (error) throw error;
      
      // Redirect to thank you page
      navigate('/obrigado');
    } catch (error) {
      console.error('Error submitting RSVP:', error);
      throw error;
    }
  };

  return (
    <div className="min-h-screen py-12 px-4">
      <PageHeader 
        title="Confirmação de Presença" 
        subtitle="Será uma honra contar com a sua presença no nosso grande dia"
      />
      
      <div className="container mx-auto max-w-4xl mb-10">
        <div className="bg-wedding-beige-100 p-6 rounded-lg text-center mb-8">
          <p className="text-wedding-blue-800">
            Por favor, confirme sua presença até o dia <strong>10 de junho de 2025</strong>.
          </p>
        </div>
      </div>
      
      <RsvpForm onSubmit={handleSubmit} />
    </div>
  );
};

export default RsvpPage;